import { useMutation } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import toast from "react-hot-toast";

import { GenericErrorResponse } from "app/api/types";
import parseError from "app/lib/parseError";
import { createPayment } from "app/api/payment";
import { BUSHA_ROOT } from "app/constants/routes";
import { useNavigate } from "react-router-dom";

export default function useCreatePayment() {
  const navigate = useNavigate();

  const { isLoading, data, mutate, error } = useMutation(createPayment, {
    onError(error: AxiosError<GenericErrorResponse>) {
      const errorMessage = parseError(error) as string;

      if (axios.isAxiosError(error)) {
        if (error.response?.status === 401) {
          navigate(BUSHA_ROOT, { replace: true });
        }
        if (error.response?.data.error.message.toLowerCase().includes("insufficient balance")) {
          return;
        }
      }

      toast.error(errorMessage);
    }
  });

  return { isLoading, data: data?.data?.data, createPayment: mutate, error: error ? parseError(error) as string : null };
}
